import countryCodes from "@data/country_codes.json";

const getAddressRequestFilter = (countryCode: string): string => {
  const code = countryCodes[countryCode.toUpperCase()];
  if (!code) {
    throw new Error("No country code found");
  }

  return `countryCode:${code}`;
};
export default getAddressRequestFilter;
